import { render, staticRenderFns } from "./ListProductColorsComponent.vue?vue&type=template&id=b06727ce&scoped=true"
import script from "./ListProductColorsComponent.vue?vue&type=script&lang=js"
export * from "./ListProductColorsComponent.vue?vue&type=script&lang=js"
import style0 from "./ListProductColorsComponent.vue?vue&type=style&index=0&id=b06727ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06727ce",
  null
  
)

export default component.exports